import moment from 'moment';
import {
	forEach, isUndefined, pickBy, set, omit,
} from 'lodash';
import {
	CoordinatorService, OfficerService, InvoiceService, AgencyService, LocationService,
} from '@services';
import { apiErrorHandler } from '@config/utils';
import utils from '@utils';

import Actions from '.';

const getCoordinatorsData = () => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'coordinator', true));
	CoordinatorService.getAll({ minimalData : true })
		.then(({ data }) => {
			const newData = utils.buildSelectArrayOptionsFromAPIResponse({
				data,
				labelProperty : 'Name',
				valueProperty : 'Id',
				imageURL      : 'OrganizationLogoUrl',
				subLabel      : 'LocationInfo',
			});
			dispatch(Actions.updateReports('data', 'coordinator', newData));
			dispatch(Actions.updateReports('loading', 'coordinator', false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module   : 'reports',
			property : 'loading.coordinator',
		}));
});

const getOfficersData = (organizationId = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'officer', true));
	OfficerService.getAll({ organizationId })
		.then(({ data }) => {
			const newData = utils.buildSelectArrayOptionsFromAPIResponse({
				data,
				labelProperty : 'FullName',
				valueProperty : 'Id',
				imageURL      : 'ProfilePhotoUrl',
				subLabel      : 'Department',
			});
			dispatch(Actions.updateReports('data', 'officer', newData));
			dispatch(Actions.updateReports('loading', 'officer', false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module   : 'reports',
			property : 'loading.officer',
		}));
});

const getLocationsData = (clientId = undefined, officerId = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'location', true));
	LocationService.getAll({ minimalData : true, organizationId : clientId, officerId })
		.then(({ data }) => {
			const newData = utils.buildSelectArrayOptionsFromAPIResponse({
				data,
				labelProperty : 'Name',
				valueProperty : 'Id',
			});
			dispatch(Actions.updateReports('data', 'location', newData));
			dispatch(Actions.updateReports('loading', 'location', false));
		})
		.catch(apiErrorHandler({
			dispatch,
			module   : 'reports',
			property : 'loading.location',
		}));
});

const getInvoiceHistoryReportData = (params = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	InvoiceService.getInvoiceHistoryReportData(params)
		.then(({ data }) => {
			dispatch(Actions.updateReports('loading', 'report', false));
			dispatch(Actions.updateStoreProperties({ reportData : data }));
		})
		.catch((error) => {
			dispatch(Actions.updateStoreProperties({ reportData : {} }));
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			})(error);
		});
});

const getPaymentHistoryReportData = (params = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	InvoiceService.getPaymentHistoryReportData(params)
		.then(({ data }) => {
			dispatch(Actions.updateReports('loading', 'report', false));
			dispatch(Actions.updateStoreProperties({ reportData : data }));
		})
		.catch((error) => {
			dispatch(Actions.updateStoreProperties({ reportData : {} }));
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			})(error);
		});
});

const getTransactionHistoryReportData = (params = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	InvoiceService.getTransactionHistoryReportData(params)
		.then(({ data : { PaymentReceipts } }) => {
			dispatch(Actions.updateReports('loading', 'report', false));
			dispatch(Actions.updateStoreProperties({ transactionHistoryData : PaymentReceipts }));
		})
		.catch((error) => {
			dispatch(Actions.updateStoreProperties({ transactionHistoryData : [] }));
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			})(error);
		});
});

const getClientOverviewReportData = (params = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	AgencyService.getOverview({
		includeAll : false,
		...params,
	})
		.then(({ data }) => {
			dispatch(Actions.updateReports('loading', 'report', false));
			dispatch(Actions.updateStoreProperties({ reportData : data }));
		})
		.catch((error) => {
			dispatch(Actions.updateStoreProperties({ transactionHistoryData : [] }));
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			})(error);
		});
});

const getClientOverviewExportData = (type, data = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	AgencyService.exportReport({ type, data })
		.then((response) => {
			utils.downloadReport(response);
			dispatch(Actions.updateReports('loading', 'report', false));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getLocationOverviewReportData = (params = undefined) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	LocationService.getLoactionOverview(params)
		.then(({ data }) => {
			dispatch(Actions.updateReports('loading', 'report', false));
			dispatch(Actions.updateStoreProperties({ reportData : data }));
		})
		.catch((error) => {
			dispatch(Actions.updateStoreProperties({ reportData : {} }));
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			})(error);
		});
});

const getLocationOverviewExportData = (params, data) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	LocationService.exportReport(params, data)
		.then((response) => {
			utils.downloadReport(response);
			dispatch(Actions.updateReports('loading', 'report', false));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getFilterData = () => ((dispatch) => {
	dispatch(getCoordinatorsData());
	dispatch(getLocationsData());
	dispatch(getOfficersData());
});

const resetAndCallLocations = (clientId, officerId) => ((dispatch) => {
	dispatch(Actions.resetReportsData('location'));
	dispatch(getLocationsData(clientId, officerId));
});

const resetAndCallOfficers = (organizationId) => ((dispatch) => {
	dispatch(Actions.resetReportsData('officer'));
	dispatch(getOfficersData(organizationId));
});

const getInvoiceHistoryExportData = (params, exportType) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	InvoiceService.getInvoiceHistoryExportData(params, exportType)
		.then(({ data }) => {
			utils.downloadReportFromBlobResponse(data, `rollkall_invoice_history_report.${exportType}`);
			dispatch(Actions.updateReports('loading', 'report', false));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getPaymentHistoryExportData = (params, exportType) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	InvoiceService.getPaymentHistoryExportData(params, exportType)
		.then(({ data }) => {
			utils.downloadReportFromBlobResponse(data, `rollkall_payment_history_report.${exportType}`);
			dispatch(Actions.updateReports('loading', 'report', false));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getTransactionHistoryExportData = (params, exportType) => ((dispatch) => {
	dispatch(Actions.updateReports('loading', 'report', true));
	InvoiceService.getTransactionHistoryExportData(params, exportType)
		.then(({ data }) => {
			utils.downloadReportFromBlobResponse(data, `rollkall_transaction_history_report.${exportType}`);
			dispatch(Actions.updateReports('loading', 'report', false));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getOfficerExportData = (params) => ((dispatch, getState) => {
	const { reports : { reportData } } = getState();

	dispatch(Actions.updateReports('loading', 'report', true));

	OfficerService.exportReport(params, reportData)
		.then((response) => {
			utils.downloadReport(response);
			dispatch(Actions.updateReports('loading', 'report', false));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getOfficerReportData = (queryParams) => ((dispatch) => {
	if (!queryParams.officerId) return;

	dispatch(Actions.updateReports('loading', 'report', true));
	OfficerService.getReport(queryParams)
		.then(({ data }) => {
			dispatch(Actions.updateReports('loading', 'report', false));
			dispatch(Actions.updateStoreProperties({ reportData : data }));
		})
		.catch(
			apiErrorHandler({
				dispatch,
				module   : 'reports',
				property : 'loading.report',
			}),
		);
});

const getNameFromId = (data, value) => {
	let returnData = '';
	forEach(data, (item) => {
		if (item.value === value) returnData = item.label;
	});
	return returnData;
};

const formatFilterDataForPrint = ({
	coordinatorId, officerId, locationId, fromDate, toDate,
}) => ((dispatch, getState) => {
	const filterPrintData = [];
	const { data : { coordinator, officer, location } } = getState().reports;
	if (!isUndefined(coordinatorId)) filterPrintData.push({ label : 'Coordinator', value : getNameFromId(coordinator, coordinatorId) });
	else filterPrintData.push({ label : 'Coordinator', value : 'Not Applied' });
	if (!isUndefined(officerId)) filterPrintData.push({ label : 'Officer', value : getNameFromId(officer, officerId) });
	else filterPrintData.push({ label : 'Officer', value : 'Not Applied' });
	if (!isUndefined(locationId)) filterPrintData.push({ label : 'Location', value : getNameFromId(location, locationId) });
	else filterPrintData.push({ label : 'Location', value : 'Not Applied' });
	filterPrintData.push({ label : 'From', value : fromDate });
	filterPrintData.push({ label : 'To', value : toDate });
	dispatch(Actions.updateStoreProperties({ filterPrintData }));
});

const applyFilterGetReportData = (form) => ((dispatch, getState) => {
	const { reportType } = getState().reports;
	// remove falsy values
	const params = pickBy(form, (item) => item && item !== '');
	const { fromDate, toDate, officerId } = params;
	// parse dates as YYYY-M-D Format
	set(params, ['fromDate'], moment(fromDate, 'M/D/YYYY').format('YYYY-M-D'));
	set(params, ['toDate'], moment(toDate, 'M/D/YYYY').format('YYYY-M-D'));

	switch (reportType) {
		case 0:
			dispatch(getInvoiceHistoryReportData(params));
			break;
		case 1:
			dispatch(getPaymentHistoryReportData(params));
			break;
		case 2:
			dispatch(getTransactionHistoryReportData(params));
			break;
		case 3:
			dispatch(getOfficerReportData({
				startDateRange : fromDate,
				endDateRange   : toDate,
				officerId,
			}));
			break;
		case 4:
			dispatch(getClientOverviewReportData({
				startDateRange : fromDate,
				endDateRange   : toDate,
			}));
			break;
		case 5:
			dispatch(getLocationOverviewReportData(omit(params, ['coordinatorId'])));
			break;
		default:
			break;
	}
	dispatch(formatFilterDataForPrint(params));
});

const applyFilterExportReportData = (exportType, form) => ((dispatch, getState) => {
	// remove falsy values
	const { reportType, reportData } = getState().reports;
	const params = pickBy(form, (item) => item && item !== '');
	const {
		fromDate, toDate, officerId, locationId,
	} = params;
	// parse dates as YYYY-M-D Format
	set(params, ['fromDate'], moment(fromDate, 'M/D/YYYY').format('YYYY-M-D'));
	set(params, ['toDate'], moment(toDate, 'M/D/YYYY').format('YYYY-M-D'));

	switch (reportType) {
		case 0:
			dispatch(getInvoiceHistoryExportData(params, exportType));
			break;
		case 1:
			dispatch(getPaymentHistoryExportData(params, exportType));
			break;
		case 2:
			dispatch(getTransactionHistoryExportData(params, exportType));
			break;
		case 3:
			dispatch(getOfficerExportData(({
				type           : exportType,
				startDateRange : fromDate,
				endDateRange   : toDate,
				officerId,
			})));
			break;
		case 4:
			dispatch(getClientOverviewExportData(exportType, reportData));
			break;
		case 5:
			dispatch(getLocationOverviewExportData({ type : exportType, locationId }, reportData));
			break;
		default:
			break;
	}
});

export default {
	getFilterData,
	getOfficersData,
	getLocationsData,
	resetAndCallOfficers,
	resetAndCallLocations,
	applyFilterGetReportData,
	applyFilterExportReportData,
	getLocationOverviewReportData,
	getOfficerReportData,
};
